import Reveal from "./Reveal";

const COMMITMENTS = [
  {
    text: "The co-founder or partner you meet on the first call leads your engagement to completion.",
  },
  {
    text: "Your plan is written by the person you spoke with.",
    small: "Nothing is drafted by a junior and signed by a senior.",
  },
  {
    text: "You have our direct lines. Calls and messages reach us, and we answer them ourselves.",
  },
  {
    text: "We take on a small number of family office engagements at any one time.",
    small: "Enough to do each one properly, few enough to stay reachable.",
  },
];

export default function Commitment() {
  return (
    <section className="band band-canvas" id="access" data-testid="section-access">
      <div className="container access-grid">
        <Reveal>
          <div>
            <p className="eyebrow">Our commitment</p>
            <h2>
              Direct access. <em>Every time.</em>
            </h2>
            <p className="lede">
              Large firms staff family office work with a partner at the pitch
              and a team of associates afterwards. We do not have associates.
              The firm is small on purpose so that this remains true.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <ul className="commitment-list" data-testid="commitment-list">
            {COMMITMENTS.map((item) => (
              <li key={item.text} data-testid="commitment-item">
                <p className="commitment-main">{item.text}</p>
                {item.small && <p className="commitment-small">{item.small}</p>}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
